// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_aw-3";
export var contentContainer = "_aw-0";
export var editorContainer = "_aw-1";
export var quillInputForm = "_aw-2";
export var zoneDivider = "_aw-4";